import React, { Component } from "react";
import PropTypes from "prop-types";
import { Animated, Easing, Text } from "react-native";

class ColoredText extends Component {
    render() {
        const { style, content, color, progress } = this.props;

        return (
            <Text style={style} allowFontScaling={true}>
                <Text style={{ color: color.to }}>{content.substring(0, progress)}</Text>
                <Text style={{ color: color.from }}>{content.substring(progress)}</Text>
            </Text>
        )
    }
}

const AnimatedColoredText = Animated.createAnimatedComponent(ColoredText);

class GradientText extends Component {

    constructor(props) {
        super(props);

        this._animated = null;
        this.progress = new Animated.Value(0);
    }

    componentDidMount() {
        this.startAnimation();
    }

    componentWillUnmount() {
        this._animated = null;
    }

    startAnimation() {
        this._animated = Animated.timing(this.progress, {
            toValue: 1,
            duration: this.props.duration,
            easing: Easing.linear,
        }).start(() => {
            this.props.onEnd && this.props.onEnd();
        });
    }

    render() {
        return (
            <AnimatedColoredText
                {...this.props}
                progress={this.progress.interpolate({
                    inputRange: [0, 1],
                    outputRange: [0, this.props.content.length],
                })}
            />
        );
    }
}

GradientText.propTypes = {
    style: PropTypes.object,
    content: PropTypes.string,
    duration: PropTypes.number,
    color: PropTypes.object,
    onEnd: PropTypes.func,
};

GradientText.defaultProps = {
    style: {},
    content: "",
    duration: 0,
    color: { from: "", to: "" },
    onEnd: null,
};

export default GradientText;


